export default __webpack_public_path__ + "static/media/b48.91bba9c7.png";